import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    padding: '0 4px'
  },
  sectionTitle: {
    marginBottom: 12
  },
  addControl: {
    marginBottom: 16
  },
  list: {
    maxHeight: 320,
    overflowY: 'auto'
  },
  listRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: 8,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0
    }
  },
  listRowMain: {
    flex: 1,
    minWidth: 0,
    '& > *': {
      display: 'block'
    }
  },
  listRowRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0
  }
});
export default useStyles;